import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { AddressSearchFormContainer } from '../containers/AddressSearchFormContainer.js';

const AddressSearchForm = (props)=>/*#__PURE__*/ React.createElement(AddressSearchFormContainer, swcHelpers.extends({}, props))
;

export { AddressSearchForm };
//# sourceMappingURL=AddressSearchForm.js.map
